var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2998 4C7.7118 4 4.7998 6.912 4.7998 10.5C4.7998 14.088 7.7118 17 11.2998 17C14.8878 17 17.7998 14.088 17.7998 10.5C17.7998 6.912 14.8878 4 11.2998 4ZM11.2998 15.7C8.4268 15.7 6.0998 13.373 6.0998 10.5C6.0998 7.627 8.4268 5.3 11.2998 5.3C14.1728 5.3 16.4998 7.627 16.4998 10.5C16.4998 13.373 14.1728 15.7 11.2998 15.7Z",
    fill: "#533F04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04971 11.4754C8.58818 11.4754 9.02471 11.0389 9.02471 10.5004C9.02471 9.96191 8.58818 9.52539 8.04971 9.52539C7.51123 9.52539 7.07471 9.96191 7.07471 10.5004C7.07471 11.0389 7.51123 11.4754 8.04971 11.4754Z",
    fill: "#533F04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2997 11.4754C11.8382 11.4754 12.2747 11.0389 12.2747 10.5004C12.2747 9.96191 11.8382 9.52539 11.2997 9.52539C10.7612 9.52539 10.3247 9.96191 10.3247 10.5004C10.3247 11.0389 10.7612 11.4754 11.2997 11.4754Z",
    fill: "#533F04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5497 11.4754C15.0882 11.4754 15.5247 11.0389 15.5247 10.5004C15.5247 9.96191 15.0882 9.52539 14.5497 9.52539C14.0112 9.52539 13.5747 9.96191 13.5747 10.5004C13.5747 11.0389 14.0112 11.4754 14.5497 11.4754Z",
    fill: "#533F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.15f8bad744fb6136affebd192e4b66c5.svg";
export { ForwardRef as ReactComponent };